import React, { Component } from 'react';
import Icon from '../Icon';
import { Popover, Badge, Avatar, Modal } from 'antd';
import { Link } from 'dva/router';
import cx from 'classnames';
import './style/index.less';
import SearchBox from './SearchBox';
import $$ from 'cmn-utils';
import { framework_tool, component_tool } from '../../../tool';
import PasswordForm from '../../../components/myhome/userInfo/passwordForm'
import { connect } from "dva";
import { request } from '@/utils/commonUtils';
let { WizSpin, WizModal,WizIcon } = component_tool;
let { ossFileUtils,modelUtils,WizContainer } = framework_tool

/**     
 * 其本本局头部区域
 */
class NavBar extends WizContainer {
  constructor(props) {
    super(props);
    this.state = {
      type: '',//password,email,mobile
      visible: false,
      openSearchBox: false,
    };
  }

  static defaultProps = {
    fixed: true,
    theme: '' //'bg-dark',
  };

  componentWillMount() {
    this.user = storage.getStorage('user') ? storage.getStorage('user') : { nickName: '游客' };
  }

  componentDidMount() { }

  // shouldComponentUpdate(nprops, nstate) {
  //   return true
  // }

  propsAndStateOnChange = {
    editPassowrd: this._editPassowrdOver.bind(this),
  }

  toggleFullScreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  /**
   * 修改密码
   * @param {*} nextProps
   * @param {*} nextState
   */
   _editPassowrdOver(nextProps, nextState) {
    let { editPassowrd } = nextProps
    if (editPassowrd['success'] && editPassowrd['data']) {
      wizNotice.success('修改密码成功');
      nextState['visible'] = false;
      return true;
    } else {
      wizNotice.error(editPassowrd['msg'] || '修改密码失败')
      return false;
    }
  }

  


  /**
   * 修改密码
   * @param {*} params
   */
   eidtPassword=({ oldPassword, password })=> {
    let user = storage.getStorage('user');
     this.doAction({
       path:'userSafe/editPassowrd',
       payload: {
         key:'userSafe@editPassowrd',
         apiParams: {
           id: user['id'],
           personId: user['personId'],
           oldPassword: Base64.encode(oldPassword),
           newPassword: Base64.encode(password)
         }
       },
     })
  }

  onCloseSearchBox = () => {
    this.setState({
      openSearchBox: false
    });
  };

  onOpenSearchBox = () => {
    this.setState({
      openSearchBox: true
    });
  };

  /**
    * 触发弹框方法
    */
  _open = (type) => {
     let key = type === 'email' ? 'emailCode' : 'mobileCode'
     let r = this.state[key] ? {} : { [key]: false }
     this.setState({ type: type + '@' + new Date().getTime(), visible: true, ...r })
  }

  _close = () => {
    this.setState({ visible: false })
  }
  /**
  * modal视图
  */
  _modal = () => {
    let { type } = this.state
    return <WizModal {...this._getModalProps(type)} />
  }
  /**
     * modal属性
     */
  _getModalProps = (type) => {
    /* let user = storage.getStorage('user') */
    let { userSafeLoading } = this.props;
    /* let { emailCode, mobileCode } = this.state */
    let pub = {
      key: type,
      visible: this.state.visible,
      footer: null,
      maskClosable: false,
      onCancel: () => { this._close() },
      mask: true,
    }
    let r = {
      password: {
        ...pub,
        title: '修改密码',
        children: <WizSpin spinning={userSafeLoading} >
          <PasswordForm submit={(e) => { this.eidtPassword(e) }} onCancel={() => { this._close() }} />
        </WizSpin>
      },
    }
    if (type) {
      return r[type.split('@')[0]]
    }
  }

  render() {
    const { openSearchBox } = this.state;
    const {
      fixed,
      theme,
      onCollapseLeftSide,
      collapsed,
      onExpandTopBar,
      toggleSidebarHeader,
      isMobile
    } = this.props;
    const classnames = cx('navbar', {
      'navbar-fixed-top': !!fixed,
      'navbar-sm': isMobile ? true : collapsed,
      ['bg-' + theme]: !!theme
    });
    let avatarUrl = getOssFilePath(this.user.avatar)
    avatarUrl = this.user.avatar ? avatarUrl : require('assets/images/head1.png')

    return (
      <header className={classnames}>
        <div className="navbar-branding">
          <Link className="navbar-brand" to="/">
            <img src={constants.files.sys_main_logo} alt="logo" />
            <b>{constants.env.sys_short_name}</b>
          </Link>
          <span className="toggle_sidemenu_l" onClick={onCollapseLeftSide}>
            <Icon type="lines" />
          </span>
        </div>
        <div className="navbar-title">
          <b className="navbar-title-brand">{constants.env.sys_full_name}</b>
        </div>
        <div className='my-home-user-safe'>
          {this._modal()}
        </div>
        {/* <ul className="nav navbar-nav navbar-left clearfix">
          {collapsed || isMobile ? null : (
            <li>
              <a className="sidebar-menu-toggle" onClick={toggleSidebarHeader}>
                <Icon type="ruby" />
              </a>
            </li>
          )}
          <li>
            <a onClick={onExpandTopBar}>
              <Icon type="wand" />
            </a>
          </li>
          {isMobile ? (
            <li className="mini-search" onClick={this.onOpenSearchBox}>
              <a>
                <Icon type="search" antd />
              </a>
            </li>
          ) : (
            <li onClick={this.toggleFullScreen}>
              <a className="request-fullscreen">
                <Icon type="screen-full" />
              </a>
            </li>
          )}
        </ul> */}
        {/* {isMobile ? null : (
          <form className="navbar-form navbar-search clearfix">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="全文检索"
                onClick={this.onOpenSearchBox}
              />
            </div>
          </form>
        )} */}
        <ul className="nav navbar-nav navbar-right clearfix">
          {/* <li>
            <a href="https://github.com/LANIF-UI/dva-boot-admin">
              <Icon type="github" antd />
            </a>
          </li> */}
          {/* <li className="dropdown">
            <Popover
              placement="bottomRight"
              title={'通知'}
              overlayClassName={cx('navbar-popup', { [theme]: !!theme })}
              content={''}
              trigger="click"
            >
              <a className="dropdown-toggle">
                <Icon type="radio-tower" />
              </a>
            </Popover>
          </li> */}
          <li className="dropdown">
            <Popover
              placement="bottomRight"
              title={'欢迎您,' + (this.user.fullName || '')}
              overlayClassName={cx('navbar-popup', { [theme]: !!theme })}
              content={<UserDropDown handleLogout={this.props.handleLogout} open={this._open} display={this.user.changePassword? 'block' : 'none'}/>}
              trigger="click"
            >
              <a className="dropdown-toggle">
                <Badge dot>
                  <Avatar src={avatarUrl}>
                    {this.user.fullName}
                  </Avatar>
                </Badge>
              </a>
            </Popover>
          </li>
        </ul>
        <SearchBox visible={openSearchBox} onClose={this.onCloseSearchBox} />
      </header>
    );
  }
}

const UserDropDown = props => (
  <ul className="dropdown-menu list-group dropdown-persist">
    {/* <li className="list-group-item">
      <a className="animated animated-short fadeInUp">
        <Icon type="mail" /> 信息
        <Badge count={5} className="label" />
      </a>
    </li>
    <li className="list-group-item">
      <a className="animated animated-short fadeInUp">
        <Icon type="users" /> 好友
        <Badge count={6} className="label" />
      </a>
    </li>
    <li className="list-group-item">
      {
        storage.getStorage('app_sys_type') === 'demo' ?
          <Link to="/sys" onClick={() => { storage.setStorage('app_sys_type', 'sys') }} className="animated animated-short fadeInUp">
            <Icon type="ring" /> 切换后台
          </Link>
          :
          <Link to="/demo" onClick={() => { storage.setStorage('app_sys_type', 'demo') }} className="animated animated-short fadeInUp">
            <Icon type="ring" /> 切换组件库
          </Link>
      }
    </li>
    <li className="list-group-item">
      <Link to="/" onClick={() => { storage.setStorage('app_sys_type', 'stu') }} className="animated animated-short fadeInUp">
        <Icon type="ring" /> 切换前台
      </Link>
    </li> */}
    <li className="list-group-item dropdown-footer">
      <div style={{padding: '10px 0px 10px 0px',display:props.display}}
        onClick={() => {
          props.open && props.open('password')
        }}
      >
        
        <WizIcon type="lock" /> 修改密码
      </div>
    </li>
    <li className="list-group-item dropdown-footer">
      <Link to="/sign/login"
        onClick={() => {
          props.handleLogout && props.handleLogout()
        }}
      >
        <Icon type="poweroff" /> 退出
      </Link>
    </li>
  </ul>
);

const mapStateToProps = (state, ownProps) => {
  const { userSafe, userInfo } = state;
  const editPassowrd = modelUtils.getModelEntity(userSafe, 'userSafe@editPassowrd');
  const load = modelUtils.getLoadingState(state, ['userSafe']);
  const _userInfo = modelUtils.getModelEntity(userInfo, 'userInfo@getUserInfo');
  return {
    editPassowrd,
    userInfo: _userInfo,
    ...load
  };
};
export default connect(mapStateToProps)(NavBar);
